/* Rebelly tote-kampanj v2 (draft-tema): haller varukorgen i synk med kampanjen
   "en Rebelly-tote pa kopet med Hostreset och prenumeration".

   Kvalificerare: rad med en pack-variant (Hostreset, Arsreset, 10-paketet) ELLER valfri
   rad med selling_plan_allocation (prenumeration via Loop).
   Antal totes = summan av antal over alla kvalificerande rader (2 pack = 2 totes,
   1 pack + 1 prenumeration = 2 totes), tak MAX_TOTES. Noll kvalificerare = ingen tote.

   Strategi:
   1) PRIMART: temats alla cart-mutationer gar via fetch (verifierat i theme.dev.js,
      enda XHR:en ar Ajaxinate/infinite scroll). Vi wrappar fetch och KEDJAR:
      nar en mutation mot /cart/(add|change|update|clear) lyckas synkar vi toten
      klart INNAN temat far se svaret. Nar temat sedan redirectar till /cart eller
      renderar drawern ar varukorgen redan komplett - en enda paint, ingen reload.
   2) FALLBACK (t.ex. back-knapp med gammalt state): synk vid sidladdning och
      uppdatera UI utan reload via stegen:
      a) no-op-dispatch av temats egna "theme:cart:update" pa en cart-rad
         (temat gor da change + omrendering med intakta event-bindningar),
      b) annars section-swap av [data-items-holder]/[data-cart-price-holder]
         fran sektionen api-cart-items (Section Rendering API),
      c) annars, ENDAST pa /cart och max en gang per 10 s (sessionStorage-vakt),
         location.reload().
   Toten laggs ALDRIG med selling plan (ren engangsrad, foljer inte med pa
   Loop-fornyelser), qty klampas till 1, allt ar try/catch-skyddat och kan
   aldrig blockera ett kop (4 s timeout pa kedjningen).
   Rollback: ta bort denna fil + script-taggen i layout/theme.liquid. */
(function () {
  'use strict';
  if (window.__rblToteSync) return;
  window.__rblToteSync = true;

  /* ── Konfiguration ── */
  var TOTE_VARIANT_ID = 57068509593925; /* Rebelly Tote (produkt 15673065210181), enda varianten */
  /* Pristest V37 (2026-09-30): Hostreset saljs pa en NY variant (3 897 kr, 59537381458245, samma som
     RBL_PACK_ID i snippets/product.liquid). Den gamla pack-varianten (3 297 kr) ligger kvar som
     kvalificerare sa att en varukorg som foljt med fran MAIN behaller sin tote. */
  /* V40 (2026-10-02): Arsreset (6 fastor, 7 194 kr, SKU REB-6PACK, 59550664884549 = RBL_SIX_ID i
     snippets/product.liquid) ger tote exakt som Hostreset: en per pack. */
  var PACK_VARIANT_IDS = [parseInt('59537381458245', 10)]; /* steg 3 2026-10-15: raderade/obefintliga id borttagna */
  /* 10-paketet (10 fastor, SKU REB-10PACK) saljs inte langre i temat men kan kopas via gamla lankar.
     Det ger fortfarande tote, en per pack (Leo 2026-09-30). */
  var YEAR_VARIANT_ID = parseInt('59537381491013', 10);
  var YEAR_GETS_TOTE = true;
  function isPackLine(line) {
    if (PACK_VARIANT_IDS.indexOf(line.variant_id) !== -1) return true;
    return YEAR_GETS_TOTE && line.variant_id === YEAR_VARIANT_ID;
  }
  /* Flexleverans (pristest V37): avgiftsraden (SKU REB-FLEX, egen produkt) bar BARA radegenskapen
     _flex_for = huvudradens variant-id och den synliga etiketten Startdatum. Den far aldrig ligga ensam
     i varukorgen och aldrig ha antal over 1. Ger aldrig tote (ingen selling plan, ingen pack-variant).
     Huvudraden kanns igen pa variant-id, att den bar en flexdag (_leveransdag) och samma Startdatum. */
  function isFlexLine(line) {
    return !!(line && (line.sku === 'REB-FLEX' || (line.properties && line.properties._flex_for)));
  }
  function flexHasMain(flex, items) {
    var fp = flex.properties || {};
    for (var i = 0; i < items.length; i++) {
      var l = items[i];
      if (l === flex || isFlexLine(l)) continue;
      var lp = l.properties || {};
      if (String(l.variant_id) === String(fp._flex_for) && lp._leveransdag &&
          (!fp.Startdatum || lp.Startdatum === fp.Startdatum)) return true;
    }
    return false;
  }
  /* Early bird (tema B, 2026-09-11): engangsvarianterna 57326747615557 (1 499 kr) och 59287771119941
     (sen bokning, "3 dagar / ----", 1 699 kr) ar medvetet INTE kvalificerare: engang ger ingen tote,
     tidig som sen. Kvalificerarna ar oforandrade: pack-variant (isPackLine) eller selling_plan_allocation. */
  var MAX_TOTES = 20;                   /* sakerhetstak: aldrig fler an sa manga totes */
  var CHAIN_TIMEOUT_MS = 4000;          /* max tid kedjningen far forsena temats svar */
  var CART_RE = /\/cart\/(add|change|update|clear)/;

  var origFetch = window.fetch.bind(window);
  var syncing = false;
  var syncTimer = null;

  function jsonPost(url, body) {
    return origFetch(url, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify(body)
    });
  }

  function readCart() {
    return origFetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); });
  }

  /* Las varukorgen och gor toten ratt. Loser med { changed: bool }.
     Far ALDRIG kasta - fel ats upp och rapporteras som "inget andrat". */
  /* Flexrader forst: en flexrad utan sin huvudrad tas bort, antal over 1 klampas till 1.
     Loser med { cart, changed }. Far ALDRIG kasta. Kors i samma kedja som toten, sa temat
     ser en fardig varukorg. Kunden har tagit bort huvudraden = flexavgiften foljer med ut. */
  function settleFlex(cart) {
    try {
      var items = cart.items || [], updates = {}, n = 0;
      items.forEach(function (line) {
        if (!isFlexLine(line)) return;
        if (!flexHasMain(line, items)) { updates[line.key] = 0; n++; }
        else if (line.quantity > 1) { updates[line.key] = 1; n++; }
      });
      if (!n) return Promise.resolve({ cart: cart, changed: false });
      return jsonPost('/cart/update.js', { updates: updates })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (c) { return { cart: (c && c.items) ? c : cart, changed: true }; })
        .catch(function () { return { cart: cart, changed: false }; });
    } catch (e) { return Promise.resolve({ cart: cart, changed: false }); }
  }

  function settleTote() {
    return readCart()
      .then(settleFlex)
      .then(function (flex) {
        return Promise.resolve(settleToteIn(flex.cart)).then(function (res) {
          return { changed: !!(res && res.changed) || flex.changed };
        });
      })
      .catch(function () { return { changed: false }; });
  }

  function settleToteIn(cart) {
    return Promise.resolve(cart)
      .then(function (cart) {
        /* N = summan av antal over ALLA kvalificerande rader:
           varje rad med pack-varianten + varje rad med selling plan (prenumeration).
           1 pack + 1 pren = 2 totes, 2 pack = 2 totes, 3 pren = 3 totes. */
        var wanted = 0;
        var tote = null;
        (cart.items || []).forEach(function (line) {
          if (line.variant_id === TOTE_VARIANT_ID) { tote = line; return; }
          var qty = parseInt(line.quantity, 10);
          if (!(qty > 0)) return;
          if (isPackLine(line) || line.selling_plan_allocation) wanted += qty;
        });
        if (wanted > MAX_TOTES) wanted = MAX_TOTES; /* sakerhetstak mot skenande antal */

        if (wanted === 0) {
          if (!tote) return { changed: false };
          return jsonPost('/cart/change.js', { id: tote.key, quantity: 0 })
            .then(function (r) { return { changed: r.ok }; });
        }
        if (!tote) {
          /* engangsrad: ingen selling plan -> foljer aldrig med pa Loop-fornyelser */
          return jsonPost('/cart/add.js', { items: [{ id: TOTE_VARIANT_ID, quantity: wanted, properties: { _pa_kopet: '1' } }] })
            .then(function (r) { return { changed: r.ok }; });
        }
        if (tote.quantity !== wanted) {
          /* klampar bade upp och ner till exakt N */
          return jsonPost('/cart/change.js', { id: tote.key, quantity: wanted })
            .then(function (r) { return { changed: r.ok }; });
        }
        return { changed: false };
      })
      .catch(function () { return { changed: false }; });
  }

  function withTimeout(promise, ms) {
    return Promise.race([
      promise,
      new Promise(function (resolve) { setTimeout(function () { resolve({ changed: false }); }, ms); })
    ]);
  }

  /* ── 1) PRIMART: kedja temats cart-mutationer ── */
  try {
    window.fetch = function () {
      var arg = arguments[0];
      var url = (arg && arg.url) ? arg.url : arg;
      var isCartMutation = false;
      try { isCartMutation = typeof url === 'string' && CART_RE.test(url); } catch (e) {}
      var p = origFetch.apply(window, arguments);
      if (!isCartMutation) return p;
      /* V50 (2026-10-12): kundvagnslådan (snippets/rbl-kundvagn.liquid) skickar headern X-Rbl-Defer-Tote pa sitt
         /cart/add.js. Da slapps svaret direkt (ladan ritas utan att vanta) och toten synkas strax efter; nar den ar
         klar skickas document-handelsen rbl:tote:settled { changed } sa att ladan ritar om en gang. */
      var defer = false;
      try {
        var h = arguments[1] && arguments[1].headers;
        defer = !!(h && (h['X-Rbl-Defer-Tote'] || (typeof h.get === 'function' && h.get('X-Rbl-Defer-Tote'))));
      } catch (e) {}
      if (defer) {
        p.then(function (res) {
          if (!res || !res.ok) return;
          var go = function () {
            if (syncing) { setTimeout(go, 150); return; }
            syncing = true;
            withTimeout(settleTote(), CHAIN_TIMEOUT_MS)
              .catch(function () { return { changed: false }; })
              .then(function (r) {
                syncing = false;
                try { document.dispatchEvent(new CustomEvent('rbl:tote:settled', { detail: { changed: !!(r && r.changed) } })); } catch (e) {}
              });
          };
          go();
        }, function () {});
        return p;
      }
      return p.then(function (res) {
        if (!res || !res.ok || syncing) return res;
        syncing = true;
        return withTimeout(settleTote(), CHAIN_TIMEOUT_MS)
          .catch(function () {})
          .then(function () { syncing = false; return res; });
      });
    };
  } catch (e) {}

  /* Backstop for eventuell XHR-baserad cart-mutation (finns ingen i temat idag) */
  try {
    var origOpen = XMLHttpRequest.prototype.open;
    XMLHttpRequest.prototype.open = function (method, url) {
      try {
        if (typeof url === 'string' && CART_RE.test(url)) {
          this.addEventListener('loadend', scheduleFallback);
        }
      } catch (e) {}
      return origOpen.apply(this, arguments);
    };
  } catch (e) {}

  /* ── 2) FALLBACK vid sidladdning: synka + uppdatera UI utan reload ── */

  function refreshUiViaThemeDispatch() {
    /* No-op-andring via temats eget flode: lyssnaren pa varje cart-rad kor
       updateCart({id, quantity}) -> change + getCart + build + cartEvents.
       Samma qty = ofarlig andring, men ger en fullstandig omrendering. */
    try {
      var item = document.querySelector('[data-cart-item][data-item][data-item-index]');
      if (!item) return false;
      var key = item.getAttribute('data-item');
      var qtyInput = item.querySelector('input[name^="updates"], input[type="number"], [data-quantity-field]');
      var qty = qtyInput ? parseInt(qtyInput.value, 10) : NaN;
      if (!key || !(qty > 0)) return false;
      item.dispatchEvent(new CustomEvent('theme:cart:update', { detail: { id: key, quantity: qty }, bubbles: true }));
      return true;
    } catch (e) { return false; }
  }

  function refreshUiViaSectionSwap() {
    /* Section Rendering API: samma sektion som temat sjalvt anvander (api-cart-items). */
    var itemsHolder = document.querySelector('[data-items-holder]');
    var priceHolder = document.querySelector('[data-cart-price-holder]');
    if (!itemsHolder && !priceHolder) return Promise.resolve(false);
    return origFetch('/cart?section_id=api-cart-items', { credentials: 'same-origin' })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var tmp = document.createElement('div');
        tmp.innerHTML = html;
        var api = tmp.querySelector('[data-api-content]');
        if (!api) return false;
        var lines = api.querySelector('[data-api-line-items]');
        var price = api.querySelector('[data-api-cart-price]');
        if (itemsHolder) itemsHolder.innerHTML = lines ? lines.innerHTML : '';
        if (priceHolder && price) priceHolder.innerHTML = price.innerHTML;
        return true;
      })
      .catch(function () { return false; });
  }

  function guardedReload() {
    /* Sista utvag, bara pa /cart och max en gang per 10 s. */
    try {
      if (!/^\/cart(\/|$)/.test(window.location.pathname)) return;
      var last = parseInt(sessionStorage.getItem('rblToteReload') || '0', 10);
      if (Date.now() - last < 10000) return;
      sessionStorage.setItem('rblToteReload', String(Date.now()));
      window.location.reload();
    } catch (e) {}
  }

  function fallbackSync() {
    if (syncing) return;
    syncing = true;
    settleTote()
      .then(function (result) {
        syncing = false;
        if (!result || !result.changed) return;
        if (refreshUiViaThemeDispatch()) return;
        return refreshUiViaSectionSwap().then(function (swapped) {
          if (!swapped) guardedReload();
        });
      })
      .catch(function () { syncing = false; });
  }

  function scheduleFallback() {
    try {
      clearTimeout(syncTimer);
      syncTimer = setTimeout(fallbackSync, 700);
    } catch (e) {}
  }

  try {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { fallbackSync(); });
    } else {
      fallbackSync();
    }
    window.addEventListener('pageshow', function (ev) { if (ev && ev.persisted) fallbackSync(); });
  } catch (e) {}
})();
